import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthFlowService } from '../services/auth-wrapper/auth-flow.service';

/**
 * Guard to handle the Auth0 signup flow by invoking the registration process and preventing route activation.
 */
export const SignupGuard: CanActivateFn = () => {
    const authFlowService = inject(AuthFlowService);

    // Triggering the Auth0 signup flow
    authFlowService.register();

    // Preventing route activation as the signup flow is being handled externally
    return false;
};
